<i18n>
{
	"en": {
		"header": "References",
		"noReferencesFound": "No References...",
		"code": "Code",
		"shortDescription.no": "Short Desc. (NO)",
		"shortDescription.en": "Short Desc. (EN)",
		"description.no": "Description (NO)",
		"description.en": "Description (EN)",
		"failedToFetch": "Failed to fetch references",
		"failedToUpdate": "Failed to update reference",
		"updatedReference": "Reference Updated",
		"isSystemReference": "System",
		"isActive": "Active"
	},
	"no": {
		"header": "Referanser",
		"noReferencesFound": "Ingen referanser...",
		"code": "Kode",
		"shortDescription.no": "Kort besk. (NO)",
		"shortDescription.en": "Kort besk. (EN)",
		"description.no": "Beskrivelse (NO)",
		"description.en": "Beskrivelse (EN)",
		"failedToFetch": "Kunne ikke hente referanser",
		"failedToUpdate": "Kunne ikke oppdatere referanse",
		"updatedReference": "Referanse oppdatert",
		"isSystemReference": "System",
		"isActive": "Aktiv"
	}
}
</i18n>

<template>
	<t-vertical-panel class="references">
		<div slot="header" class="references-header">
			<t-panel-header size="md" icon="comment" type="bp">
				{{ $t('header') }}
			</t-panel-header>
		</div>
		
		<div class="references-content">
			<t-grid
				v-if="references"
				ref="grid"
				:columnDefinitions="columnDefinitions"
				:defaultColumnDefinition="defaultColumnDefinitions"
				:rowHeight="40"
				:items="references"
				localStorageId="referencesList"
			>
				<template v-slot:isActive="{ item }">
					<div class="center-checkbox">
						<t-checkbox
							:checked="item.isActive"
							name="isActive"
							@change="updateActive(item, $event)"
						/>
					</div>
				</template>
				<template v-slot:isSystemReference="{ item }">
					<div class="center-checkbox">
						<t-checkbox
							:checked="item.isSystemReference"
							name="isSystemReference"
							disabled
						/>
					</div>
				</template>

				<template #shortDescription.no="{ item }">
					<t-text-input
						:value="item.shortDescription.no"
						:isInvalid="errors.shortDescription && item.id === errors.id"
						@change="updateValue( item, $event, 'shortDescription.no' )"
					/>
				</template>
				<template #shortDescription.en="{ item }">
					<t-text-input
						:value="item.shortDescription.en"
						:isInvalid="errors.shortDescription && item.id === errors.id"
						@change="updateValue( item, $event, 'shortDescription.en' )"
					/>
				</template>
			</t-grid>
			<t-no-content-panel
				v-else
				:text="$t('noReferencesFound')"
				icon="book"
				iconType="bp"
			/>
			<t-overlay
				:isShown="loading"
				absolute
				loader
			/>
		</div>
	</t-vertical-panel>
</template>

<script>
import { mapState, mapActions } from './store/references.store.js';

export default {
	name: 'References',
	data() {
		return {
			defaultColumnDefinitions: {
				resizable: true,
				headerFilterInputWithButton: true,
			},
			rowsSelected: 0,
		};
	},
	computed: {
		...mapState([
			'references',
			'loading',
			'errors'
		]),
		columnDefinitions() {
			return [
				{
					field: 'isActive',
					displayName: this.$t('isActive'),
					width: 70,
					align: 'center'
				},
				{
					field: 'code',
					displayName: this.$t('code'),
					width: 60,
					align: 'center',
					sortDirection: 'asc'
				},
				{
					field: 'isSystemReference',
					displayName: this.$t('isSystemReference'),
					width: 70,
					align: 'center'
				},
				{
					field: 'shortDescription.no',
					displayName: this.$t('shortDescription.no'),
					minWidth: 100
				},
				{
					field: 'shortDescription.en',
					displayName: this.$t('shortDescription.en'),
					minWidth: 100
				},
				{
					field: 'description.no',
					displayName: this.$t('description.no'),
					minWidth: 100
				},
				{
					field: 'description.en',
					displayName: this.$t('description.en'),
					minWidth: 100
				},
			];
		}
	},
	async mounted() {
		try {
			await this.getReferences();
		} catch (e) {
			this.$notify({
				type: 'error',
				title: this.$t('failedToFetch')
			});
		}
	},
	methods:{
		...mapActions([
			'getReferences',
			'setReferenceActive',
			'setReference'
		]),
		onRowsSelected(ids) {
			this.rowsSelected = ids.length;
		},
		async updateActive(reference, data ) {
			try {
				await this.setReferenceActive({ reference: reference, data });
				this.$notify({
					type: 'success',
					title: this.$t('updatedReference'),
				});
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t('failedToUpdate'),
				});
			}
		},

		async updateValue(reference, data, prop) {
			try {
				await this.setReference({ reference: reference, data: data, prop });
				this.$notify({
					type: 'success',
					title: this.$t('updatedReference'),
					text: reference.code
				});
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t('failedToUpdateDescription'),
					text: reference.code
				});
			}
		},
	}
};

</script>

<style lang="scss" scoped>
.references {
	.references-header {
		height: 100%;
		display: flex;
		align-items: center;
		padding-left: 15px;
	}
	.references-sub-header {
		display: flex;
		padding: 0px 15px;
		height: 100%;
		align-items: center;
		justify-content: flex-end;

		> button {
			margin: 10px;
		}
	}
	.references-content {
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0px 5px;
	}
}

.center-checkbox {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding-right: 5px!important;
}
</style>
